export function toSnapshot(dineroObject) {
  return dineroObject.toJSON();
}